import { render, staticRenderFns } from "./soushin-kanryo.vue?vue&type=template&id=1868b0f1&"
import script from "./soushin-kanryo.vue?vue&type=script&lang=js&"
export * from "./soushin-kanryo.vue?vue&type=script&lang=js&"
import style0 from "./soushin-kanryo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports